import { postComment, getCommentById, getCommentList, putComment, deleteComment } from 'services/commentService';
import { toast } from 'react-toastify';
import { processErrorResponse } from 'utils/errorHandler';

export const createComment = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'COMMENT_POST_REQUEST' });
    try {
        const result = await postComment(endpoint, data);
        dispatch({ type: 'COMMENT_POST_SUCCESS', payload: result });

        toast.success("Comment has been added successfully!");
    } catch (error) {
        dispatch({ type: 'COMMENT_POST_FAILURE', error: error.message });
        processErrorResponse(error);
        throw error;
    }
};

export const updateComment = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'COMMENT_PUT_REQUEST' });
    try {
        const result = await putComment(endpoint, data);
        dispatch({ type: 'COMMENT_PUT_SUCCESS', payload: result });

        toast.success("Comment has been updated successfully!");
    } catch (error) {
        dispatch({ type: 'COMMENT_PUT_FAILURE', error: error.message });
        processErrorResponse(error);
        throw error;
    }
};

export const getComments = (params) => async (dispatch) => {
    try {
        dispatch({ type: "GET_COMMENTS_LOADING" });
        const query = params ? `?${new URLSearchParams(params).toString()}` : "";

        const data = await getCommentList(`/comments${query}`);
        dispatch({ type: "GET_COMMENTS_SUCCESS", payload: data });
    } catch (error) {
        dispatch({ type: "GET_COMMENTS_FAILURE", payload: error.message });
        processErrorResponse(error);
    }
};

export const fetchCommentById = (id) => async (dispatch) => {
    dispatch({ type: 'COMMENT_GETBYID_REQUEST' });
    try {
        const result = await getCommentById('/comments', id);
        dispatch({ type: 'COMMENT_GETBYID_SUCCESS', payload: result });
        return result; // Return the result so it can be used
    } catch (error) {
        dispatch({ type: 'COMMENT_GETBYID_FAILURE', error: error.message });
        processErrorResponse(error);
        throw error;
    }
};

export const removeComment = (id) => async (dispatch) => {
    dispatch({ type: 'COMMENT_DELETE_REQUEST' });
    try {
        const result = await deleteComment('/comments', id);
        dispatch({ type: 'COMMENT_DELETE_SUCCESS', payload: result });
        toast.success("Comment has been deleted successfully!");
        return result;
    } catch (error) {
        dispatch({ type: 'COMMENT_DELETE_FAILURE', error: error.message });
        processErrorResponse(error);
        throw error;
    }
};
